type CampaignProgressProps = {
  percentage: number;
};

const CampaignProgress: React.FC<CampaignProgressProps> = ({percentage}) => {
  const clamped = Math.min(100, Math.max(0, percentage));

  return (
    <div className="h-2.5 w-full rounded-[10px]">
      <div
        className="h-full rounded-[10px] bg-orange transition-[width] duration-300"
        style={{width: `${clamped}%`}}
      />
    </div>
  );
};

export default CampaignProgress;
